import React, { useState } from 'react';
import styles from '../auth.module.css';
import { useNavigate } from 'react-router-dom';
import PhoneInput from '@/shared/ui/PhoneInput';
import { toast } from "react-toastify";
import { register } from "../api";
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const Registration = () => {
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isSubmitting,setIsSubmitting] = useState(false);


    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        if (!phone || !password || !confirmPassword) {
            toast.error("Заполните все поля");
            return;
        }

        if (password !== confirmPassword) {
            toast.error("Пароли не совпадают");
            return;
        }

        try {
            const res = await register({ phone, password, confirmPassword, email });
            const data = res.data;

            const accessToken = data.accessToken;
            const refreshToken = data.refreshToken;

            localStorage.setItem('access_token', accessToken);
            localStorage.setItem('refresh_token', refreshToken);

            navigate("/auth/complete-reg");
        } catch (error) {
            toast.error(error?.response?.data?.message || "Ошибка регистрации");
        }finally {
            setIsSubmitting(false);
        }
    };

    return (
        <section className={`${styles.authSection} container-custom`}>
            <img className={styles.logo} src="/images/logo%20new.svg" alt="Логотип ПОДЗЕМЕЛЬЕ" />
            <h1 className={`${styles.h1} par1`}>Регистрация</h1>

            <form className={styles.form} onSubmit={handleSubmit}>
                <PhoneInput
                    value={phone}
                    onChange={setPhone}
                />

                <input
                    type="email"
                    className={`input`}
                    placeholder={`Email`}
                    value={email}
                    onChange={(e)=>setEmail(e.target.value)}
                />

                <div className={styles.passwordWrapper}>
                    <input
                        type={showPassword ? "text" : "password"}
                        className="input"
                        placeholder="Пароль"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <span className={styles.eyeIcon} onClick={() => setShowPassword(prev => !prev)}>
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                </div>

                <div className={styles.passwordWrapper}>
                    <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="input"
                        placeholder="Повторите пароль"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <span className={styles.eyeIcon} onClick={() => setShowConfirmPassword(prev => !prev)}>
                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                </div>

                <button
                    type="submit"
                    className="btn btn-red-filled w-100"
                    disabled={!phone || !password || !confirmPassword || isSubmitting}
                >
                    Далее
                </button>
            </form>
        </section>
    );
};

export default Registration;
